import React from "react";
import { cn } from "../../../utils/cn";
import { ReactComponent as Check } from "../../../assets/icons/check.svg";
import CheckMarkIcon from "../../../assets/icons/CheckMarkIcon";

const Checkbox = ({
  id,
  name,
  label,
  checked = false,
  onChange,
  onBlur,
  isRequired = false,
  disabled = false,
  error,
  containerStyle = "",
  labelStyle = "",
  checkboxStyle = "",
  errorStyle = "",
  className = "",
  isLoginCheckbox = false,
  isNewApproach = false,
  ...props
}) => {
  // Determine effective border color
  let effectiveBorderColor = "var(--color-stroke-01)";
  if (error) effectiveBorderColor = "var(--color-error)";
  else if (!isLoginCheckbox && checked) effectiveBorderColor = "transparent";
  else if (isLoginCheckbox) effectiveBorderColor = "var(--color-stroke-01)";

  const isPaidCheckbox = className?.includes("checkbox-paid");

  return (
    <div className={cn("flex flex-col font-inter", containerStyle)}>
      <div className="flex items-start gap-2">
        {/* Checkbox */}
        <div className="relative flex items-center">
          <input
            type="checkbox"
            id={id}
            name={name}
            checked={checked}
            onChange={(e) => onChange && onChange(name, e.target.checked)}
            onBlur={() => onBlur && onBlur(name, checked)}
            disabled={disabled}
            className={cn(
              "w-[16px] h-[16px] rounded-sm appearance-none cursor-pointer transition-all duration-200 ease-in-out",
              isLoginCheckbox
                ? "border !border-[var(--color-stroke-13)]"
                : checked
                ? "border-2 rounded-sm"
                : "border-2 border-[var(--color-stroke-01)] rounded-sm",
              disabled && "opacity-50 cursor-not-allowed",
              className,
              checkboxStyle
            )}
            style={{
              ...(isLoginCheckbox && {
                backgroundColor: checked
                  ? "transparent"
                  : "var(--color-background-01)",
              }),
              ...(!isLoginCheckbox &&
                checked &&
                isPaidCheckbox && {
                  borderColor: `var(--color-checkbox-paid)`,
                  borderImage: "none",
                }),
              ...(!isLoginCheckbox &&
                checked &&
                !isPaidCheckbox && {
                  borderImage:
                    "linear-gradient(88.95deg, #7B02CB 16.46%, #C102CB 100%) 1",
                  borderColor: "transparent",
                }),
            }}
            {...props}
          />

          {/* Checkmark */}
          {checked &&
            (isNewApproach ? (
              <div
                className={cn(
                  "absolute inset-0 flex items-center justify-center pointer-events-none",
                  isPaidCheckbox
                    ? "text-[var(--color-checkbox-paid)]"
                    : "text-[var(--color-primary)]"
                )}
                style={{ opacity: isPaidCheckbox ? 0.35 : 1 }}
              >
                <CheckMarkIcon width={10} height={10} useGradient />
              </div>
            ) : (
              <Check
                className="absolute pointer-events-none"
                fill={
                  isPaidCheckbox
                    ? "var(--color-checkbox-paid)"
                    : effectiveBorderColor
                }
                style={{
                  width: "10px",
                  height: "10px",
                  top: "3px",
                  left: "3px",
                  opacity: isPaidCheckbox ? 0.35 : 1,
                }}
              />
            ))}
        </div>

        {/* Label */}
        {label && (
          <label
            htmlFor={id}
            className={cn(
              "text-sm font-medium text-[var(--color-label)] cursor-pointer select-none",
              disabled && "opacity-50 cursor-not-allowed",
              labelStyle
            )}
          >
            {label}
            {isRequired && (
              <span className="ml-1 text-[var(--color-error)]">*</span>
            )}
          </label>
        )}
      </div>

      {/* Error message */}
      {error && (
        <span
          className={cn(
            "mt-1 text-sm font-medium text-[var(--color-error)]",
            errorStyle
          )}
        >
          {error}
        </span>
      )}
    </div>
  );
};

export default Checkbox;
